
import React from 'react';
import './InfoBox.css';
import { connect } from 'react-redux';
import {
  toggleDisplays,
} from '../state/uiControl/uiControl.actions';
import { RootState } from 'typesafe-actions';
import Box from './Box';

export const BulletinBox: React.FC<BulletinBoxProps> = ({
  selected,
  selectedImage,
}) => {
  
  if (!selected) {
    return null;
  }

  const entryToShow = {
    title: selected.name,
    content: selected.data.content,
  };

  return (
    <Box
      selectedImage={selectedImage}
      textContentProps={entryToShow}
    />
  );
};

const mapStateToProps = (state: RootState,) => {

  return {
    selected: state.uiControl.selectedBulletin,
    data: state.speciesData.bulletinData,
    selectedImage: state.uiControl.selectedImage,
  };
};

const dispatchProps = {
  toggleDisplays,
};

type BulletinBoxProps = ReturnType<typeof mapStateToProps> & typeof dispatchProps;


export default connect(
  mapStateToProps,
  dispatchProps
)(BulletinBox);